import React from 'react';
import { OverlayTooltip, Placement } from '../../overlay';
import Button from '../button';
import { BulkElementConfiguration } from './bulk-action.type';
import ImageIcon from '../../../../components/images/image-icon';
import Icon from '../icon';

type IProps = {
  data: BulkElementConfiguration[];
};

const BulkAction: React.FC<IProps> = ({ data }) => {
  const renderButton = (
    shouldShowPopover,
    label,
    popoverText,
    actionConfiguration,
    index,
  ) => {
    if (shouldShowPopover) {
      return (
        <OverlayTooltip text={popoverText} placement={Placement.Top}>
          <Button key={index} {...actionConfiguration}>
            {' '}
            {label}
          </Button>
        </OverlayTooltip>
      );
    }
    return (
      <Button key={index} {...actionConfiguration}>
        {' '}
        {label}
      </Button>
    );
  };

  const renderIcon = (
    shouldShowPopover,
    label,
    popoverText,
    actionConfiguration,
    className,
    index,
  ) => {
    if (shouldShowPopover) {
      return (
        <OverlayTooltip text={popoverText} placement={Placement.Bottom}>
          <div
            key={index}
            className={`bulk-action-image-icon ${className}`}
            {...actionConfiguration}
          />
        </OverlayTooltip>
      );
    }
    return (
      <ImageIcon {...actionConfiguration} src={actionConfiguration.icon} />
    );
  };

  const renderIconButton = (
    shouldShowPopover,
    label,
    popoverText,
    actionConfiguration,
    className,
    index,
  ) => {
    if (shouldShowPopover) {
      return (
        <OverlayTooltip text={popoverText} placement={Placement.Bottom}>
          <Button
            iconOnly={<Icon identifier={actionConfiguration.icon} />}
            key={index}
            className={`bulk-action-icon-button ${className}`}
            {...actionConfiguration}
          />
        </OverlayTooltip>
      );
    }
    return (
      <Button
        iconOnly={<Icon identifier={actionConfiguration.icon} />}
        key={index}
        className={`bulk-action-icon-button ${className}`}
        {...actionConfiguration}
      />
    );
  };

  const createComponent = (
    {
      renderComponent,
      label,
      actionConfiguration,
      popoverText,
      shouldShowPopover,
      className,
    }: BulkElementConfiguration,
    index,
  ) => {
    switch (renderComponent) {
      case 'Custom':
        return actionConfiguration?.component || <></>
      case 'Button':
        return renderButton(
          shouldShowPopover,
          label,
          popoverText,
          actionConfiguration,
          index,
        );
      case 'Icon':
        return renderIcon(
          shouldShowPopover,
          label,
          popoverText,
          actionConfiguration,
          className,
          index,
        );
      case 'IconButton':
        return renderIconButton(
          shouldShowPopover,
          label,
          popoverText,
          actionConfiguration,
          className,
          index,
        );

      default:
        break;
    }

    return null;
  };

  return (
    <>
      {data.map((item: BulkElementConfiguration, index) =>
        createComponent(item, index),
      )}
    </>
  );
};

export default BulkAction;
